import { render } from "./Learn.vue?vue&type=template&id=a480ed60&scoped=true"
import script from "./Learn.vue?vue&type=script&lang=js"
export * from "./Learn.vue?vue&type=script&lang=js"

import "./Learn.vue?vue&type=style&index=0&id=a480ed60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a480ed60"]])

export default __exports__